/*
 * Copyright (c) 2023 Your Company Name
 * All rights reserved.
 */
/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
/*eslint-disable*/
import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";

// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  addPaiementAction,
  upadatePaiementAction,
} from "action/paiementAction";

// style for this view
import stylesExtended from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import { useHistory } from "react-router";
import { connect } from "react-redux";

import * as service from "../../services/paiementService";
import * as notif from "components/Notification/notification";
import { useMemo } from "react";
import { useParams } from "react-router-dom-v5-compat";

const useStyles = makeStyles(styles);
const useStylesExtended = makeStyles(stylesExtended);

const paiementClientUpdate = (props) => {
  //const history = useNavigate();
  const [paramClientId, setParamClientId] = useState("");
  const [paramPayementClientId, setParamPayementClientId] = useState("");

  const [openNotif, setOpenNotif] = useState(false);

  // type validation
  const [dureePayement, setdureePayement] = React.useState("");
  const [dureePayementState, setdureePayementState] = React.useState("");

  // type validation
  //const [categoryPayement, setCategoryPayement] = React.useState("");
  //const [categoryPayementState, setCategoryPayementState] = React.useState("");

  const [montantPayement, setmontantPayement] = React.useState("");
  const [montantPayementState, setmontantPayementState] = React.useState("");

  const [typePayement, settypePayement] = React.useState("");
  const [typePayementState, settypePayementState] = React.useState("");

  const [listCategoryPayement, setListCategoryPayement] = React.useState("");
  const [categorySelectFinal, setCategorySelectFinal] = React.useState("");

  const [catPaySelectElem, setCatPaySelectElem] = React.useState("");

  const [
    listCategoryPayementState,
    setListCategoryPayementState,
  ] = React.useState("");

  useEffect(() => {
    if (openNotif === true) {
      if (props.loadPayementFromSaga.loading === false) {
        let msg;
        let title;

        if (props.loadPayementFromSaga.error.length > 0) {
          if (paramPayementClientId) {
            title = "Echeque Mise a jour payement";
            msg = "Mise a jours payement echoué";
          } else {
            title = "Echeque ajout payement";
            msg = "La payement  n a pas ete effectuer";
          }
          notif.showFailedNotification(title, msg);
        } else {
          if (paramPayementClientId) {
            title = "Mise a jour payement";
            msg = "La payement " + "  a ete mise a jours";
          } else {
            title = "Ajout  payement";
            msg = "La payement effectuer";
          }
          notif.showSuccessNotification(title, msg);
        }
        setOpenNotif(false);
      }
    }
  }, [props.loadPayementFromSaga]);

  useEffect(() => {
    //console.log(" paramID = ",props.match.params)
    if (paramPayementClientId) {
      const data = {
        paiementID: paramPayementClientId,
      };

      service
        .getItemPaiement(data)
        .then((res) => {
          setdureePayement(res.numeroCarteSim);
          if (verifyLength(res.numeroCarteSim, 0)) {
            setdureePayementState("success");
          }

          setmontantPayement(res.montantPayementSim);
          if (verifyLength(res.montantPayementSim, 0)) {
            setmontantPayementState("success");
          }
          settypePayement(res.numeroDeCommandeSim);
          if (verifyLength(res.numeroDeCommandeSim, 0)) {
            settypePayementState("success");
          }
        })
        .catch((error) => {
          //console.log('error = ',error)
        });
    }
  }, [paramPayementClientId]);

  const paramURLPaiementID = useParams().paiementId;

  const selectCategoryPayement = async () => {
    const listCategory = await service.listCategoryPaiement();

    setListCategoryPayementState(listCategory);
    if (listCategory.length > 0) {
      setCategorySelectFinal(listCategory[0].labellite);
    }
  };

  const handleCategory = (even) => {
    setCategorySelectFinal(even.target.value);
  };

  useEffect(() => {
    selectCategoryPayement();
  }, []);

  useEffect(() => {
    if (listCategoryPayementState !== undefined) {
      // console.log("listCategoryPayementState =>", listCategoryPayementState);
      if (Array.isArray(listCategoryPayementState)) {
        console.log("listCategoryPayementState =>", listCategoryPayementState);
        const catPayement = listCategoryPayementState.map((catPay) => {
          return (
            <MenuItem
              key={catPay.identifiantCatPaiement}
              classes={{
                root: classesExtended.selectMenuItem,
                selected: classesExtended.selectMenuItemSelected,
              }}
              selected={
                categorySelectFinal === catPay.identifiantCatPaiement
                  ? true
                  : false
              }
              value={catPay.labellite}
            >
              {catPay.label}
            </MenuItem>
          );
        });

        const catPayElem = () => {
          return (
            <Select
              MenuProps={{
                className: classesExtended.selectMenu,
              }}
              classes={{
                select: classesExtended.select,
              }}
              value={categorySelectFinal}
              onChange={handleCategory}
              inputProps={{
                name: "categoryItem",
                id: "categoryItem",
              }}
            >
              <MenuItem
                disabled
                classes={{
                  root: classesExtended.selectMenuItem,
                }}
              >
                Category Payement
              </MenuItem>

              {catPayement}
              {
                //deviceSelectSuplementaire
              }
            </Select>
          );
        };

        setCatPaySelectElem(catPayElem);
      }
    }
  }, [listCategoryPayementState, categorySelectFinal]);

  useEffect(() => {
    setParamPayementClientId(paramURLPaiementID);
  }, []);

  const paramURLID = useParams().id;

  useEffect(() => {
    setParamClientId(paramURLID);
  }, []);

  const successDelete = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Deleted!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Your imaginary file has been deleted.
      </SweetAlert>
    );
  };
  const cancelDetele = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Your imaginary file is safe :)
      </SweetAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };

  // function that returns true if value is email, false otherwise
  const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  // function that verifies if a string has a given length or not
  const verifyLength = (value, length) => {
    if (value.length > length) {
      return true;
    }
    return false;
  };
  // function that verifies if value contains only numbers
  const verifyNumber = (value) => {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  };

  const typeClick = () => {
    let error = false;

    if (dureePayement === "") {
      setdureePayementState("error");
      error = true;
    }

    if (montantPayement === "") {
      error = true;
      setmontantPayementState("error");
    }

    if (typePayement === "") {
      error = true;
      settypePayementState("error");
    }

    const data = {
      montant: montantPayement,
      typePayement: typePayement,
      categoryPayement: categorySelectFinal,
      os: "BACKOFFICE",
      nbrMois: dureePayement,
      clientId: paramClientId,
    };

    if (error === false) {
      setOpenNotif(true);
      if (paramPayementClientId) {
        // console.log("payementUpdateDispatch")
        props.payementUpdateDispatch(data);
      } else {
        //  console.log("data = ", data)
        // console.log("ready to go  = payementAddDispatch", data)

        props.payementAddDispatch(data);
      }

      //history('/')
    }
  };

  const classes = useStyles();
  const classesExtended = useStylesExtended();

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info" text>
            <CardText color="info">
              <h4 className={classes.cardTitle}>Type Validation</h4>
            </CardText>
          </CardHeader>
          <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    dureePayement
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={dureePayementState === "success"}
                    error={dureePayementState === "error"}
                    id="dureePayement"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setdureePayementState("success");
                        } else {
                          setdureePayementState("error");
                        }
                        setdureePayement(event.target.value);
                      },
                      value: dureePayement,

                      type: "text",
                      endAdornment:
                        dureePayementState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>duree Abonnement</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    montantPayement
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={montantPayementState === "success"}
                    error={montantPayementState === "error"}
                    id="montantPayement"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setmontantPayementState("success");
                        } else {
                          setmontantPayementState("error");
                        }
                        setmontantPayement(event.target.value);
                      },
                      value: montantPayement,
                      type: "text",
                      endAdornment:
                        montantPayementState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>montantPayement</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    typePayement
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={typePayementState === "success"}
                    error={typePayementState === "error"}
                    id="typePayement"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          settypePayementState("success");
                        } else {
                          settypePayementState("error");
                        }
                        settypePayement(event.target.value);
                      },
                      value: typePayement,
                      type: "text",
                      endAdornment:
                        typePayementState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>typePayement</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    Category Payement
                  </FormLabel>
                </GridItem>

                <GridItem xs={12} sm={7}>
                  <FormControl
                    fullWidth
                    className={classesExtended.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="category-select"
                      className={classesExtended.selectLabel}
                    ></InputLabel>
                    {catPaySelectElem}
                  </FormControl>
                </GridItem>
              </GridContainer>
            </form>
          </CardBody>
          <CardFooter className={classes.justifyContentCenter}>
            <Button color="info" onClick={typeClick}>
              Valider
            </Button>
          </CardFooter>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    loadPayementFromSaga: state.paiements,
  };
};

const mapsDispatchToProps = (dispatch) => {
  return {
    payementAddDispatch: (data) => {
      dispatch(addPaiementAction(data));
    },
    payementUpdateDispatch: (data) => {
      dispatch(upadatePaiementAction(data));
    },
  };
};

export default connect(
  mapStateToProps,
  mapsDispatchToProps
)(paiementClientUpdate);
